import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependecy'
import { TemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
  <!-- Search Icon -->
  <wa-icon name="search" class="header-icon" label="Search"
    aria-label="Search"
    alt="Search"
    aria-hidden="false"
    focusable="true"
    tabindex="0"
  ></wa-icon>
`

class NavHeaderUtilitySearch extends HTMLElement {
  private isSearchBoxVisible: boolean = false
  private _iconEl: EventTarget | null = null

  private onIconClick = (ev: Event) => {
    ev.preventDefault()
    console.log('Search icon clicked inside NavHeaderUtilitySearch')
    this.toggleSearchBox()
  }

  private onIconKeydown = (ev: Event) => {
    const ke = ev as KeyboardEvent
    if (ke.key === 'Enter' || ke.key === ' ' || ke.key === 'Spacebar') {
      ke.preventDefault()
      this.onIconClick(ke as unknown as Event)
    }
  }

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderUtilitySearch connectedCallback', this)
    const shadow = this.shadowRoot
    if (!shadow) return

    const icon = shadow.querySelector('wa-icon')
    if (icon) {
      this._iconEl = icon as EventTarget
      try { icon.setAttribute('role', 'button') } catch { }
      icon.addEventListener('click', this.onIconClick)
      icon.addEventListener('keydown', this.onIconKeydown as EventListener)
    }
  }

  disconnectedCallback() {
    if (this._iconEl) {
      (this._iconEl as EventTarget).removeEventListener('click', this.onIconClick);
      (this._iconEl as EventTarget).removeEventListener('keydown', this.onIconKeydown as EventListener);
      this._iconEl = null;
    }
  }

  private toggleSearchBox() {
    const ev = new CustomEvent('search-icon-clicked', { bubbles: true, composed: true })
    this.dispatchEvent(ev)
  }
}

if (!customElements.get('ts-navheader-utility-search')) {
  customElements.define('ts-navheader-utility-search', NavHeaderUtilitySearch)
}
export { NavHeaderUtilitySearch }
